import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Percent } from "lucide-react";
import { usePromotions } from "@/hooks/usePromotions";
import AddPromotionDialog from "./AddPromotionDialog";
import PromotionCard from "./PromotionCard";

interface Service {
  id: string;
  name: string;
}

interface PromotionsManagementProps {
  providerId: string;
  services: Service[];
}

const PromotionsManagement = ({ providerId, services }: PromotionsManagementProps) => {
  const { data: promotions, isLoading, refetch } = usePromotions(providerId);

  const handlePromotionUpdate = () => {
    refetch();
  };

  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {[...Array(3)].map((_, i) => (
          <div key={i} className="h-64 bg-gray-200 rounded animate-pulse"></div>
        ))}
      </div>
    );
  }

  return (
    <Card>
      <CardHeader>
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-4 sm:space-y-0">
          <CardTitle className="flex items-center space-x-2">
            <Percent className="h-5 w-5" />
            <span>Promotions</span>
          </CardTitle>
          {services && services.length > 0 && (
            <AddPromotionDialog
              providerId={providerId}
              services={services}
              onPromotionAdded={handlePromotionUpdate}
            />
          )}
        </div>
      </CardHeader>
      
      <CardContent>
        {promotions && promotions.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {promotions.map((promotion) => (
              <PromotionCard
                key={promotion.id}
                promotion={promotion}
                services={services}
                onPromotionUpdated={handlePromotionUpdate}
              />
            ))}
          </div>
        ) : (
          <div className="text-center py-8 text-gray-500">
            <Percent className="h-12 w-12 mx-auto mb-4 text-gray-300" />
            <p>No promotions created yet</p>
            {services.length > 0 ? (
              <div className="mt-4">
                <AddPromotionDialog
                  providerId={providerId}
                  services={services}
                  onPromotionAdded={handlePromotionUpdate}
                />
              </div>
            ) : (
              <p className="text-sm mt-2 text-gray-400">
                Create services first to add promotions
              </p>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default PromotionsManagement;